export default __webpack_public_path__ + "static/media/error.15837238.png";